module.exports = __webpack_public_path__ + "static/img/PicoPico_content@2x.fdc4978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PicoPico_content@2x.png
// module id = kb5l
// module chunks = 0